import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class RecebimentosService {

  constructor(
    private http: HttpClient,
    private util: UtilService
  ) {}

  public listar(dados: any) {
    return this.http.get(
      `${environment.apiURL}/Logado/Recebimentos/Listar`,
      { params: dados }
    );
  }

  public listarFiltros() {
    return this.http.get(
      `${environment.apiURL}/Logado/Recebimentos/ListarFiltros`
    );
  }

  public listarCobrancasCardHome() {
    return this.http.get(
      `${environment.apiURL}/Logado/Recebimentos/ListarCobrancasCardHome`
    );
  }

  public gerarBoleto(codCobranca: number) {
    return this.http.get(
      `${environment.apiURL}/Logado/Recebimentos/GerarBoleto`,
      {
        params: { codCobranca: codCobranca.toString() },
        responseType: "blob"
      }
    );
  }

  public dadosBoleto(codCobranca: number) {
    return this.http.get(
      `${environment.apiURL}/Logado/Recebimentos/DadosBoleto`,
      {
        params: { codCobranca: codCobranca.toString() }
      }
    );
  }

}
